<template>
  <div class="evaluation-pay-failure-view">
    <h1><i class="iconfont iconweitongguo"></i>支付未通过</h1>
    <p>30分钟内未付款，该订单将被取消，请立即支付</p>
    <footer>
      <gt-button style="margin-right: 20px;"
                 @click="check">查看订单</gt-button>
      <button class="theme-btn"
              @click="rePay">重新支付</button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'EvaluationPayFailure',
  components: {

  },
  data () {
    return {

    }
  },
  methods: {
    check () { },
    rePay () { }
  },
  created () {

  }
}
</script>

<style lang='less' scoped>
.evaluation-pay-failure-view {
  padding-top: 100px;
  text-align: center;
  h1 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
  .iconweitongguo {
    margin-right: 10px;
    font-size: 28px;
    font-weight: normal;
    color: #e2403d;
  }
  p {
    margin-bottom: 30px;
    font-size: 14px;
    color: #333333;
  }
  button {
    width: 150px;
  }
}
</style>
